import React, { useState } from "react";
import { Button, IconButton, InputAdornment, TextField } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import RightIcon from "../../assets/images/vactor/right-black-arrow.svg";
import EyeIcon from "../../assets/images/vactor/eye.svg";

import { LightButton, PrimaryButton } from "../AllButtons/AllButtons";
import { useAppDispatch, useAppSelector } from "../../Store/store";
import { changePassword, logoutAPI } from "../../Services/auth.service";
import { openSnackbar } from "../../Slice/snackbarSlice";
import EyeLine from "../../assets/images/vactor/eye-line.svg";
import "../ChangePassword/ChangePassword.scss";
import { useNavigate } from "react-router-dom";
interface ChangePasswordProps {
    handleChangePassword: (isPasswordReset: boolean) => void;
    toogleDisplay:(isDisplayed:boolean)=>void;
}

const ChangePassword: React.FC<ChangePasswordProps> = ({ handleChangePassword,toogleDisplay }) => {
    const dispatch = useAppDispatch();
    const navigate=useNavigate();
    const user = useAppSelector(state => state.user.user);
    const [showFields, setShowFields] = useState(false);
    const [showPassword, setShowPassword] = useState({
        oldPassword: false,
        newPassword: false,
        confirmPassword: false,
    });

    const validationSchema = Yup.object({
        oldPassword: Yup.string().transform((value) => (value ? value.trim() : value)).test(
        "no-only-whitespace",
        "Password cannot be empty or only whitespace",
        (value) => !!value && value.trim().length > 0
        ).matches(/^\S*$/, "Password cannot contain spaces")
        .required("Old Password is required"),
        newPassword: Yup.string().transform((value) => (value ? value.trim() : value)).test(
            "no-only-whitespace",
            "New Password cannot be empty or only whitespace",
            (value) => !!value && value.trim().length > 0
            )
            .min(8, "Must be at least 8 characters")
            .matches(/[A-Z]/, "Must contain at least one uppercase letter")
            .matches(/\d/, "Must contain at least one number")
            .notOneOf(
                [Yup.ref("oldPassword")],
                "New password must be different from the old password"
            ).matches(/^\S*$/, "New Password cannot contain spaces")
            .required("New Password is required"),
        confirmPassword: Yup.string().transform((value) => (value ? value.trim() : value)).test(
            "no-only-whitespace",
            "Confirm Password cannot be empty or only whitespace",
            (value) => !!value && value.trim().length > 0
            ).matches(/^\S*$/, "Confirm Password cannot contain spaces")
            .oneOf([Yup.ref("newPassword")], "Passwords must match")    
            .required("Confirm Password is required"),
    });
    
    return (
        <div className="setting-card-body">
            {!showFields && (
                <Button className="change-password-label-btn" onClick={() => setShowFields(true)}>
                    <span onClick={()=>{toogleDisplay(true)}}>Change Password</span> <img src={RightIcon} alt="Arrow" />
                    
                </Button>
            )}
            {showFields && (
                <Formik
                    initialValues={{ oldPassword: "", newPassword: "", confirmPassword: "" }}
                    validationSchema={validationSchema}
                    validateOnMount={true} 
                    validateOnChange={true} 
                    validateOnBlur={true} 
                    onSubmit={async (values) => {
                        const passwordObj = {
                            email: user.email,
                            current_password: values.oldPassword,
                            new_password: values.newPassword,
                            confirm_password: values.confirmPassword,
                        };
                        const response = await dispatch(changePassword(passwordObj)).unwrap();
                        if (response.status) {
                            handleChangePassword(true)
                            dispatch(openSnackbar({message:"Password changed now login again with new password",severity:"success"}))
                            await dispatch(logoutAPI());
                            await navigate('/login')
                        }
                        else {
                            dispatch(openSnackbar({ message: response.message || "Something went wrong", severity: "error" }))
                        }

                    }}
                >
                    {({ errors, touched, handleChange, handleBlur, handleSubmit, values, isValid, dirty }) => {
                        return (
                            <>
                                <h4 className="card-title">Change Password</h4>
                                <Form onSubmit={handleSubmit} className="password-form">                                  
                                    <div className="change-password-body">
                                        <div className="input-form-field-wrapper">
                                            <TextField
                                                className="out-label-input-text"
                                                name="oldPassword"
                                                placeholder="Old Password"
                                                margin="normal"
                                                variant="outlined"
                                                fullWidth
                                                type={showPassword.oldPassword ? "text" : "password"}
                                                value={values.oldPassword}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.oldPassword && Boolean(errors.oldPassword)}
                                                helperText={touched.oldPassword && errors.oldPassword}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                sx={{ marginRight: "1px" }}
                                                                onClick={() =>
                                                                    setShowPassword({ ...showPassword, oldPassword: !showPassword.oldPassword })
                                                                }
                                                                edge="end"
                                                            >
                                                                <img src={showPassword.oldPassword ? EyeIcon : EyeLine} alt="Toggle password" />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </div>
                                        <div className="input-form-field-wrapper">
                                            <TextField
                                                className="out-label-input-text"
                                                name="newPassword"
                                                placeholder="New Password"
                                                margin="normal"
                                                variant="outlined"
                                                fullWidth
                                                type={showPassword.newPassword ? "text" : "password"}
                                                value={values.newPassword}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.newPassword && Boolean(errors.newPassword)}
                                                helperText={touched.newPassword && errors.newPassword}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                sx={{ marginRight: "1px" }}
                                                                onClick={() =>
                                                                    setShowPassword({ ...showPassword, newPassword: !showPassword.newPassword })
                                                                }
                                                                edge="end"
                                                            >
                                                                <img src={showPassword.newPassword ? EyeIcon : EyeLine} alt="Toggle password" />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </div>
                                        <div className="input-form-field-wrapper">
                                            <TextField
                                                className="out-label-input-text"
                                                name="confirmPassword"
                                                placeholder="Confirm Password"
                                                margin="normal"
                                                variant="outlined"
                                                fullWidth
                                                type={showPassword.confirmPassword ? "text" : "password"}
                                                value={values.confirmPassword}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.confirmPassword && Boolean(errors.confirmPassword)}
                                                helperText={touched.confirmPassword && errors.confirmPassword}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                sx={{ marginRight: "1px" }}
                                                                onClick={() =>
                                                                    setShowPassword({
                                                                        ...showPassword,
                                                                        confirmPassword: !showPassword.confirmPassword,
                                                                    })
                                                                }
                                                                edge="end"
                                                            >
                                                                <img
                                                                    src={showPassword.confirmPassword ? EyeIcon : EyeLine}
                                                                    alt="Toggle password"
                                                                />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </div>
                                        <div className="change-password-action">
                                            <LightButton
                                                onClick={() => {setShowFields(false);toogleDisplay(false)}}
                                                style= {{
                                                color: "#000",
                                                textAlign: "center",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center" , 
                                                border : "1px solid lightgray"
                                            }}
                                            >
                                                Cancel
                                            </LightButton>
                                            <PrimaryButton
                                                type="submit"
                                                style={{
                                                    backgroundColor: isValid && dirty ? "#4F46E5" : "#505050",
                                                    cursor: isValid && dirty ? "pointer" : "not-allowed",
                                                    marginLeft: "10px",
                                                    display : "flex" , 
                                                    justifyContent : "center" , 
                                                    alignItems : "center" ,  
                                                    color : "white"
                                                }}
                                            >
                                                Save
                                            </PrimaryButton>
                                        </div>
                                    </div>
                                </Form >
                            </>
                        );
                    }}
                </Formik>
            )
            }
        </div >
    );
};

export default ChangePassword;
